import React, { useEffect, useState } from 'react';
import { ImArrowUp2 } from 'react-icons/im';
import { useAuth } from '../provider/authProvider';

const Footer = () => {
    const [year] = useState(new Date().getFullYear());
    const [showTop, setShowTop] = useState(false);

    // ✅ Sólo mostrar si hay sesión
    const { token, isAuthReady } = useAuth();
    const isLoggedIn = Boolean(token || localStorage.getItem('token'));

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 240);
        if (isLoggedIn) {
            onScroll(); // estado inicial
            window.addEventListener('scroll', onScroll, { passive: true });
        }
        return () => window.removeEventListener('scroll', onScroll);
    }, [isLoggedIn]);

    return (
        <>
            <footer className="sectionFooter">
                <div className="containerCustom containerFooter">
                    <p className="textFooterCompany">
                        &#169; Moviles Pay {year} - TODOS LOS DERECHOS RESERVADOS
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
